module.exports = __webpack_public_path__ + "img/x.e9460d59.svg";